/**
 * design_handoff_accept_invitation §4 — screen 6 (Confirm decline). One
 * extra step before rejecting, replacing the old one-click red link.
 *
 * @param {{name: string, icon?: string}} organization
 * @param {string=} inviterName
 * @param {string=} role
 * @param {string} invitedEmail
 * @param {boolean} loading
 * @param {string=} errorMessage
 * @param {function} onConfirm
 * @param {function} onBack
 */
import React from "react";
import { Icon, Button } from "../../theme/untitled";
import AuthAlert from "../AuthPages/AuthAlert";
import InvitationCard from "./InvitationCard";
import styles from "../AuthPages/authForm.module.scss";
import screenStyles from "./invitationScreens.module.scss";

const ConfirmDeclineScreen = ({
  organization,
  inviterName,
  role,
  invitedEmail,
  loading,
  errorMessage,
  onConfirm,
  onBack,
}) => (
  <div>
    <h1 className={styles.title}>Decline this invitation?</h1>
    <p className={styles.sub}>
      You won't be added to {organization.name}. If you change your mind later,{" "}
      {inviterName || "the inviter"} can send a new invitation.
    </p>

    <InvitationCard
      organization={organization}
      inviterName={inviterName}
      role={role}
      invitedEmail={invitedEmail}
    />

    <div className={screenStyles.actions}>
      <Button
        hierarchy="destructive"
        fullWidth
        loading={loading}
        onClick={onConfirm}
      >
        Decline invitation
      </Button>
      <Button
        hierarchy="secondaryGray"
        fullWidth
        iconLeading={<Icon name="ArrowLeft" size={16} />}
        disabled={loading}
        onClick={onBack}
      >
        Back to invitation
      </Button>

      {errorMessage && <AuthAlert variant="error">{errorMessage}</AuthAlert>}
    </div>
  </div>
);

export default ConfirmDeclineScreen;
